export namespace CommitPnrNS {
  export interface CommitPnrRequest {
    pnrActionsOptionCode: number;
    ticketingArrangement?: TicketingArrangement[];
  }

  export interface TicketingArrangement {
    elementManagementDataReference: ElementManagementDataReference;
    indicator: string;
    date: string;
    time: string;
  }

  export interface ElementManagementDataReference {
    qualifier: string;
    number: string;
  }

  export const enum CommitType {
    'CommitWithoutSave' = 'CommitWithoutSave',
    'CommitWithSave' = 'CommitWithSave',
  }
}
